enum FormOption {
  Map = 0,
  Description,
  Publication,
  Characteristic,
  Photos,
}

export default FormOption;
